import HomeIcon from 'assets/icons/menu/home.svg';
import ProfileIcon from 'assets/icons/menu/profile.svg';
import BookingsIcon from 'assets/icons/menu/bookings.svg';
import ResourceIcon from 'assets/icons/menu/resource.svg';
import UnitsIcon from 'assets/icons/menu/units.svg';
import PricingIcon from 'assets/icons/menu/pricing.svg';
import ExperienceIcon from 'assets/icons/menu/experience.svg';
import ReportIcon from 'assets/icons/menu/reports-white.svg';

export const sections = [
    {
        title: 'Menu',
        items: [
            {
                label: 'layout.menu.home',
                path: '/home',
                icon: HomeIcon,
            },
            {
                label: 'layout.menu.profile',
                path: '/profile',
                icon: ProfileIcon,
            },
            {
                label: 'layout.menu.mybookings',
                path: '/booking',
                icon: BookingsIcon,
            },
            {
                label: 'layout.menu.reports',
                path: '/report',
                icon: ReportIcon,
            },
            {
                label: 'layout.menu.experiences',
                path: '/experience',
                icon: ExperienceIcon,
            },
            {
                label: 'layout.menu.resources',
                path: '/resource',
                icon: ResourceIcon,
            },
            {
                label: 'layout.menu.units',
                path: '/units',
                icon: UnitsIcon,
            },
            {
                label: 'layout.menu.pricing',
                path: '/price-list',
                icon: PricingIcon,
            },
        ],
    },
];
